angular.module('logbook')
.directive('sortSelector', ['$timeout', "$http", "$location", "$window", "$q", "$rootScope", 'logDataService',
function($timeout, $http, $location, $window, $q, $rootScope, logDataService) {
  return {
    restrict: 'E',

    scope: {
       selectedLog: '=',
       validSorts: '=',
       currentSorts: '=?',
       configHref: '=?',
       sortType: '='
    },

	template: require('./sort-selector.html'),

    link: function(scope, elem, attrs) {
       scope.directions = [
          {'name':'asc', label:'Ascending'},
          {'name':'desc', label:'Descending'}
       ];
       scope.configKey = 'default_sort.'+scope.sortType;
       
       scope.refreshConfig = function()
       {
          logDataService.getLogConfigs(scope.selectedLog).then(function() {
             scope.configHref = scope.selectedLog.logConfigHref[scope.configKey];
             var configuredSorts = scope.selectedLog.logConfigs[scope.configKey];
             scope.sorts = configuredSorts ? JSON.parse(configuredSorts) : [{}, {}];
             scope.validSortMap = {};
             scope.validSorts.forEach(function(sort) {
                scope.validSortMap[sort.id] = sort.desc;
             });
             if( configuredSorts )
             {
                scope.currentSorts = '';
                scope.sorts.forEach(function(sort) {
                   if( scope.currentSorts.length == 0 || sort.sort )
                   {
                      scope.currentSorts += (scope.currentSorts.length == 0 ? '' : ', ')
                         + (sort.sort ? scope.validSortMap[sort.sort] : 'System Default');
                      if( sort.sort && sort.dir )
                         scope.currentSorts += ' ' + (sort.dir == 'desc' ? 'Descending' : 'Ascending');
                   }
                });
             }
          });
       };
       
       scope.refreshConfig();
       
       
       scope.setSortField = function(order, field, $data) {
          scope.sorts[order][field] = $data;
       };
       
       
       scope.saveSorts = function() {
          if( scope.configHref )
             return $http.patch(scope.configHref, {
                value: JSON.stringify(scope.sorts)
             }).then(scope.refreshConfig);
          else
             return $http.post('/api/logConfigs', {
                dataType:'/api/dataTypes/2',
                hierarchy:'logbook.webui.config',
                log: scope.selectedLog._links.self.href,
                key: scope.configKey,
                value: JSON.stringify(scope.sorts)
             }).then(scope.refreshConfig);
       };
    }
  }
}]);
